import { useQuery } from "@tanstack/react-query";
import {
  ServiceRequestListDocumentDto,
  ServiceReportsFilterRequest,
} from "@lib/ShiOneClient";
import { CACHE_KEY_SERVICE_REQUESTS } from "../constants";
import { getElasticServiceRequests } from "@api/serviceRequestStore";
import ms from "ms";

export function useGetElasticServiceRequests(
  queryRequest: ServiceReportsFilterRequest | undefined,
) {
  return useQuery<ServiceRequestListDocumentDto, Error>({
    queryKey: [
      `${CACHE_KEY_SERVICE_REQUESTS}/${queryRequest?.queryType}/${queryRequest?.page}`,
      queryRequest,
    ],
    queryFn: () => getElasticServiceRequests(queryRequest),
    staleTime: ms("5m"),
    refetchOnWindowFocus: true,
    enabled: !!queryRequest,
  });
}
